"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EProfileElementStatus = void 0;
let EProfileElementStatus = exports.EProfileElementStatus = /*#__PURE__*/function (EProfileElementStatus) {
  EProfileElementStatus["Disabled"] = "Disabled";
  EProfileElementStatus["Optional"] = "Optional";
  EProfileElementStatus["Mandatory"] = "Mandatory";
  EProfileElementStatus["Readonly"] = "Readonly";
  EProfileElementStatus["AddOnly"] = "AddOnly";
  return EProfileElementStatus;
}({});
